import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    public toastr: ToastrService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.authenticationService.accessToken;

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    } else {
      request = request.clone({
        setHeaders: {
          "Access-Control-Allow-Origin": "*",
        },
      });
    }

    return next.handle(request).pipe(
      catchError((err) => {
        if (
          request.headers.has("errors") &&
          request.headers.get("errors") == "handled"
        ) {
          return throwError(() => err);
        }

        if (err.status === 401) {
          this.authenticationService.logout();
          location.reload();
        } else if (err.status === 500) {
          if (err.error instanceof Blob) {
            const objError = JSON.parse(this.blobToString(err.error));
            this.toastr.error(objError.Message, "Api Error");
          } else {
            this.toastr.error(err.error.Message, "Api Error");
          }
        }

        const error = err.error.message || err.error || err.statusText;
        return throwError(() => error);
      })
    );
  }
  blobToString(b) {
    let u, x;
    u = URL.createObjectURL(b);
    x = new XMLHttpRequest();
    x.open("GET", u, false); // although sync, you're not fetching over internet
    x.send();
    URL.revokeObjectURL(u);
    return x.responseText;
  }
}
